<template>
  <div class="filter__header">
    <p>Bitte Filter wählen</p>
    <button @click="closeFilter" aria-label="Filter schließen">
      <IconClose aria-hidden="true" />
    </button>
  </div>
  <hr />
  <div class="filter__section">
    <p class="filter__category">Nach Tag</p>
    <div class="filter__pills">
      <Pill label="Montag" :active="dayTime.Montag" @click="toggleDayTime('Montag')" />
      <Pill label="Dienstag" :active="dayTime.Dienstag" @click="toggleDayTime('Dienstag')" />
      <Pill label="Mittwoch" :active="dayTime.Mittwoch" @click="toggleDayTime('Mittwoch')" />
      <Pill label="Donnerstag" :active="dayTime.Donnerstag" @click="toggleDayTime('Donnerstag')" />
      <Pill label="Freitag" :active="dayTime.Freitag" @click="toggleDayTime('Freitag')" />
      <Pill label="Samstag" :active="dayTime.Samstag" @click="toggleDayTime('Samstag')" />
    </div>
  </div>
  <hr />
  <div class="filter__section">
    <p class="filter__category">Nach Uhrzeit</p>
    <div class="filter__pills">
      <Pill
        label="Nur Vormittags"
        :active="dayTime.NurVormittags"
        @click="toggleDayTime('NurVormittags')"
      />
      <Pill
        label="Nur Nachmittags"
        :active="dayTime.NurNachmittags"
        @click="toggleDayTime('NurNachmittags')"
      />
    </div>
  </div>
  <hr />
  <div class="filter__section">
    <Button label="Auswahl übernehmen" @clicked="saveFilter" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import IconClose from '@/components/icons/IconClose.vue'
import Pill from '@/components/Pill.vue'

export default {
  components: { IconClose, Button, Pill },
  emits: ['closeFilter', 'saveDayTime'],
  props: {
    initialDayTime: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dayTime: { ...this.initialDayTime }, // cloned copy
    }
  },
  watch: {
    initialDayTime: {
      deep: true,
      handler() {
        this.dayTime = { ...this.initialDayTime } // cloned copy
      },
    },
  },
  methods: {
    closeFilter() {
      this.$emit('closeFilter')
    },
    saveFilter() {
      this.$emit('saveDayTime', { ...this.dayTime }) // cloned copy
    },
    toggleDayTime(dayTime) {
      // mutually exclusive pills
      if (dayTime === 'NurVormittags' && !this.dayTime[dayTime]) this.dayTime.NurNachmittags = false
      if (dayTime === 'NurNachmittags' && !this.dayTime[dayTime]) this.dayTime.NurVormittags = false

      this.dayTime[dayTime] = !this.dayTime[dayTime]
    },
  },
}
</script>

<style lang="scss">
.filter {
  &.el-dialog {
    max-width: 320px !important;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
      0 6px 10px 0 rgba(0, 0, 0, 0.14);

    @media (min-width: $breakpoint-mobile) {
      position: absolute;
      top: 20px;
      right: -16px;
    }
  }
  .el-dialog__body {
    padding: 0 !important;
  }

  &__header {
    @include flex-center-align;
    justify-content: space-between;
    color: $color-text-secondary;
    padding: 16px;

    button {
      background: none;
      border: none;
      padding: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:focus-visible {
        outline: 2px solid $color-info-primary;
        outline-offset: 2px;
      }
    }
  }

  &__section {
    padding: 16px;

    .button {
      width: 100%;
    }
  }

  &__category {
    @include small-text;
    margin-bottom: 4px;
  }

  &__pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__pill {
    @include small-text;
    background-color: $color-grey-light;
    border-radius: 16px;
    cursor: pointer;
    font-weight: $font-weight-medium;
    padding: 4px 20px;

    &:hover {
      background-color: $color-grey-dark;
    }
  }
}
</style>
